












import { Component, Prop, Vue } from 'vue-property-decorator';
import ItemProps from './types';

@Component
export default class ComponentsPartsHeaderAddmenu extends Vue {
  @Prop({ type: Array, default: () => [] })
  items: Array<ItemProps>;

  @Prop({ type: String, default: '#6153ac' })
  colorMain: string;

  get isItemsMoreThenTwo() {
    return this.items && this.items.length > 2;
  }

  get isCustomMainColor() {
    return this.colorMain !== '#6153ac';
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/parts/header/addmenu/Addmenu.vue